<template>
    <form
        action=""
        class="form col"
        @submit.prevent="save"
        :class="{loading}"
    >
        <div class="row">
            <div class="col">
                <label class="label">
                    QR Code:
                </label>
                <input
                    type="text"
                    required
                    class="form-control"
                    v-model="fe.code"
                >
                <error
                    name="code"
                    :errors="errors"
                />
            </div>
            <div class="col">
                <label class="label">
                    Site
                </label>
                <site-search
                    :site-id="fe.site_id"
                    @change="siteChanged"
                    :show-customer="true"
                />
                <error
                    name="site_id"
                    :errors="errors"
                />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="label">Type</label>
                <select
                    v-model="fe.type"
                    class="form-control"
                >
                    <option :value="null">
                        Select type
                    </option>
                    <option
                        v-for="type in feTypes"
                        :key="type"
                    >
                        {{ type }}
                    </option>
                </select>
                <error
                    name="type"
                    :errors="errors"
                />
            </div>
            <div class="col">
                <label class="label">
                    Size:
                </label>
                <input
                    type="text"
                    required
                    class="form-control"
                    v-model="fe.size"
                >
                <error
                    name="size"
                    :errors="errors"
                />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="label">
                    Expires:
                </label>
                <date-picker
                    v-model="fe.expires_at"
                    :options="{format: 'L'}"
                />
                <error
                    name="expires_at"
                    :errors="errors"
                />
            </div>
            <div class="col">
                <label class="label">
                    Last Tested:
                </label>
                <date-picker
                    v-model="fe.last_service_at"
                    :options="{format: 'L'}"
                />
                <error
                    name="last_service_at"
                    :errors="errors"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button class="btn btn-primary">
                    Save
                </button>
                <button
                    class="btn btn-danger"
                    @click.prevent="deleteFe"
                    v-if="!isNew"
                >
                    Delete
                </button>
                <a
                    href="#"
                    @click.prevent="$emit('back')"
                    class="btn btn-default"
                >Back</a>

                <label><input
                    type="checkbox"
                    v-model="rememberSite"
                > Use last saved site</label>
            </div>
        </div>
    </form>
</template>
<script>
import UsesErrors from '../../mixins/UsesErrors';
import UsesInfoMessage from '../../mixins/UsesInfoMessage';
import Service from '../../services/FireExtinguishersService';
import SiteSearch from '../SiteSearchComponent';
import FireEx from '../../include/FireEx';
import DatePicker from '../DateTimePickerComponent';
export default {
    components: {
        SiteSearch,
        DatePicker,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
    ],
    props: {
        feId: {
            type: Number,
            default: null,
        },
        feCode: {
            type: String,
            default: null,
        }
    },
    data () {
        return {
            fe: {},
            loading: false,
            feTypes: FireEx.types,
            rememberSite: window.localStorage.getItem('feRememberSite') !== 'false' && window.localStorage.getItem('feRememberSite') !== false,
        };
    },
    computed: {
        isNew () {
            return typeof this.fe.id === 'undefined';
        },
        engineerMode () {
            return this.$route.path.includes('engineer');
        },
    },
    watch: {
        feId: {
            immediate: true,
            handler: 'load',
        },
        feCode: {
            immediate: true,
            handler() {
                this.fe.code = this.feCode;
            }
        },
        rememberSite: {
            handler () {
                window.localStorage.setItem('feRememberSite', this.rememberSite);
                if (!this.fe.site_id && this.rememberSite) {
                    this.fe.site_id = window.localStorage.getItem('feLastSiteId');
                }
            },
        }
    },
    mounted() {
        var rememberSite = window.localStorage.getItem('feRememberSite');
        if (rememberSite === null) {
            rememberSite = true;
        }
        this.rememberSite = rememberSite !== 'false' && rememberSite !== false;
    },
    methods: {
        load () {
            this.clearErrors();
            this.loading = true;
            if (!this.feId) {
                this.reset();
                return;
            }
            Service.get(this.feId).then(res => {
                const data = res.data;
                data.last_service_at = data.last_service_at ? window.moment(data.last_service_at) : null,
                data.expires_at = data.expires_at ? window.moment(data.expires_at) : null,
                this.fe = data;
                this.loading = false;
            }).catch(err => {
                console.error(err);
                window.alert('Error: Failed to load Fire Extinguisher');
                this.$router.back();
            })
        },
        save () {
            const data = {...this.fe};
            data.last_service_at = data.last_service_at ? data.last_service_at.format('YYYY-MM-DD') : null;
            data.expires_at = data.expires_at ? data.expires_at.format('YYYY-MM-DD') : null;
            Service.save(data).then(res => {
                if (this.fe.site_id) {
                    window.localStorage.setItem('feLastSiteId', this.fe.site_id);
                }
                window.alert('Saved successfully');
                if (this.isNew) {
                    const route = this.engineerMode ? 'engineer.fe.edit' : 'office.fe.edit';
                    this.$router.replace({name: route, params: {id: res.data.id}});
                    return;
                }
                this.fe = res.data;
            }).catch(err => {
                this.captureRequestErrors(err);
                window.alert('Failed to save, check for errors');
            })
        },
        reset () {
            this.loading = false;
            this.fe = {
                site_id: this.$route.query.site_id || null,
            };
            if (!this.fe.site_id && this.rememberSite) {
                this.fe.site_id = window.localStorage.getItem('feLastSiteId');
            }
            this.clearErrors();
        },
        deleteFe () {
            const confirm = window.confirm('Are you sure you want to delete this fire extinguisher?');
            if (!confirm) {
                return;
            }
            Service.delete(this.fe.id).then(() => {
                window.alert('Deleted successfully');
                this.$router.back();
            });
        },
        siteChanged (value) {
            if (!value) {
                this.fe.site_id = null;
            }
            this.fe.site_id = value.id;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/fireExtinguishers/FormComponent.vue